import { ConfirmationDialog } from "components";
import { UserProps } from "modules/auth/users/store/actionType";
import { deletePackage } from "modules/membership_plan/commercial_membership_plan/packages/store/action";
import { useState } from "react";
import { connect } from "react-redux";

interface HandleDeleteProps {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  userData:UserProps
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & HandleDeleteProps;
const HandleDeleteUser: React.FC<Props> = ({ closeModal, userData, onDeleteUser }) => {
    const [error,setError] = useState("")
    const handleDelete = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
             await onDeleteUser(userData.id);
            closeModal(false);
        } catch {
            setError("Failed to delete user");
        }
    }
    return (
       <>
       <ConfirmationDialog 
        message={"Are you sure you want to delete this user?"}
        onConfirm={handleDelete} 
        onCancel={closeModal}
        title={`Delete ${userData.name}`}
        error={error} />
       </>
    );
}
const mapDispatchToProps = (dispatch:any) => ({
    onDeleteUser: (user_id:string) => dispatch(deletePackage(user_id)),
})
export default connect(null, mapDispatchToProps)(HandleDeleteUser);